import React from 'react';

const RedactionReasonSelect = ({ value, onChange, reasonCodes, className = '' }) => {
  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value || null)}
      className={`text-sm border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-yellow-500 ${className}`}
    >
      <option value="">No reason</option>
      {reasonCodes.map((code) => (
        <option key={code.id} value={code.code}>
          {code.label}
        </option>
      ))}
    </select>
  );
};

export default RedactionReasonSelect;
